const getPresentHour = new Date().getHours()
const getPresentMinutes = new Date().getMinutes()
const increasePresentHourByOne = Number(getPresentHour) + 1
const timeWithoutMeridian = increasePresentHourByOne > 12 ? increasePresentHourByOne - 12 : increasePresentHourByOne
const updateMeridianFormat = increasePresentHourByOne + 1 > 12 ? 'PM' : 'AM'

export { getPresentHour, getPresentMinutes, increasePresentHourByOne, timeWithoutMeridian, updateMeridianFormat }
